import React, { useState, useEffect, useRef } from 'react'

const LANGS = [
  { label: 'Español',    value: '/es/es', id: 'es' },
  { label: 'English',    value: '/es/en', id: 'en' },
  { label: 'Français',   value: '/es/fr', id: 'fr' },
  { label: 'Deutsch',    value: '/es/de', id: 'gr' },
  { label: 'Italiano',   value: '/es/it', id: 'it' },
  { label: 'Português',  value: '/es/pt', id: 'pt' },
  { label: 'Polski',     value: '/es/pl', id: 'pl' },
  { label: 'Türkçe',     value: '/es/tr', id: 'tr' },
  { label: 'Čeština',    value: '/es/cs', id: 'cz' },
  { label: 'Slovenčina', value: '/es/sk', id: 'sk' },
  { label: 'Català',     value: '/es/ca', id: 'cat' },
  { label: 'Nederlands', value: '/es/nl', id: 'nl' },
  { label: 'Norsk',      value: '/es/no', id: 'nw' },
]

export default function LoginLangSelector() {
  const [open, setOpen] = useState(false)
  const [selected, setSelected] = useState('/es/es')
  const ref = useRef(null)

  useEffect(() => {
    const match = document.cookie.match(/googtrans=([^;]+)/)
    if (match) setSelected(decodeURIComponent(match[1]))

    window.googleTranslateElementInit = () => {
      new window.google.translate.TranslateElement(
        {
          pageLanguage: 'es',
          autoDisplay: false,
          includedLanguages: LANGS.map(l => l.value.split('/')[2]).join(','),
          layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
        },
        'gt_login_element'
      )
    }
    if (!document.querySelector('script[src*="translate_a/element"]')) {
      const script = document.createElement('script')
      script.src = '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit'
      document.body.appendChild(script)
    } else if (window.google && window.google.translate) {
      window.googleTranslateElementInit()
    }

    const handleOutside = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false) }
    document.addEventListener('mousedown', handleOutside)
    return () => document.removeEventListener('mousedown', handleOutside)
  }, [])

  const handleSelect = (langValue) => {
    const parts = langValue.split('/')
    const val = `/${parts[1]}/${parts[2]}`
    document.cookie = `googtrans=${val}; path=/; domain=.vacway.es`
    document.cookie = `googtrans=${val}; path=/; domain=${window.location.hostname}`
    document.cookie = `googtrans=${val}; path=/`
    setSelected(val)
    setOpen(false)
    setTimeout(() => window.location.reload(), 10)
  }

  const current = LANGS.find(l => l.value === selected) || LANGS[0]

  return (
    <>
      <div id="gt_login_element" style={{ display: 'none' }} />
      <div ref={ref} style={{ position: 'absolute', top: 14, right: 16, zIndex: 20 }}>
        <button
          onClick={() => setOpen(o => !o)}
          style={{
            display: 'flex', alignItems: 'center', gap: 7,
            background: 'rgba(255,255,255,.1)', border: '1px solid rgba(255,255,255,.18)',
            borderRadius: 8, padding: '5px 10px 5px 7px', cursor: 'pointer',
            color: 'rgba(255,255,255,.85)', fontSize: 13, lineHeight: 1,
          }}
        >
          <img src={`/languages/${current.id}.png`} alt={current.label} style={{ width: 20, height: 20, borderRadius: 2 }} />
          <span>{current.label}</span>
          <span style={{ fontSize: 9, opacity: 0.55, marginLeft: 1 }}>▾</span>
        </button>

        {open && (
          <div style={{
            position: 'absolute', top: 'calc(100% + 4px)', right: 0,
            background: 'rgba(0,14,32,.96)', border: '1px solid rgba(255,255,255,.14)',
            borderRadius: 10, padding: '4px 0', minWidth: 156,
            boxShadow: '0 8px 28px rgba(0,0,0,.5)', maxHeight: 300, overflowY: 'auto',
          }}>
            {LANGS.map(lang => (
              <button
                key={lang.value}
                onClick={() => handleSelect(lang.value)}
                translate="no"
                style={{
                  display: 'flex', alignItems: 'center', gap: 9,
                  width: '100%', padding: '8px 14px', background: 'none', border: 'none',
                  color: selected === lang.value ? '#fff' : 'rgba(255,255,255,.55)',
                  fontWeight: selected === lang.value ? 700 : 400,
                  fontSize: 13, cursor: 'pointer', textAlign: 'left',
                  borderLeft: selected === lang.value ? '2px solid rgba(255,255,255,.4)' : '2px solid transparent',
                }}
              >
                <img src={`/languages/${lang.id}.png`} alt={lang.label} style={{ width: 20, height: 20, borderRadius: 2 }} />
                {lang.label}
              </button>
            ))}
          </div>
        )}
      </div>
    </>
  )
}
